import { Singleton } from '@visiba/instantiation';
import type { CssVariable, CssVariableSetter } from './_common';
import { MappedTheme } from './_mapped_theme';
import { ThemeModel } from './theme_model';

export class SheetIsAbsentError extends Error {
	constructor(public message: string) {
		super(message);
		this.name = 'SheetNotCreatedError';
		Object.setPrototypeOf(this, SheetIsAbsentError.prototype);
	}
}

@Singleton()
export class ThemeService {
	private styleElement: HTMLStyleElement | null = null;

	constructor() {
		// Empty
	}

	public replaceTheme(themeModel: ThemeModel): void {
		const styleElement = this.styleElement || this.createSheet();
		const sheet = styleElement.sheet;
		if (sheet == null) {
			throw new SheetIsAbsentError('The sheet for the DOM styleElement is null. This SHOULD NOT happen, report to web asap');
		}

		const segments: Array<':root {' | '}' | CssVariableSetter<CssVariable<MappedTheme>>> = [':root {'];
		for (const [key, value] of Object.entries(MappedTheme) as [keyof typeof MappedTheme, MappedTheme][]) {
			if (themeModel.theme[key] != null) {
				// TODO: REMOVE THIS ONCE NOT INJECTED ANY MORE
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				segments.push(`--visiba-global-${value}: ${themeModel.theme[key]};`);
			}
		}
		segments.push('}');

		if (sheet.cssRules.length > 0) sheet.deleteRule(0);
		sheet.insertRule(segments.join(''), 0);
	}

	private createSheet(): HTMLStyleElement {
		const styleElement = document.createElement('style');
		styleElement.appendChild(document.createTextNode(''));
		styleElement.type = 'text/css';
		styleElement.setAttribute('id', 'visiba-theme-provider');
		document.head.appendChild(styleElement);

		this.styleElement = styleElement;

		return styleElement;
	}
}
